import pick from 'lodash/pick';
import { getConversation } from 'api/tickets';

import {
  extractFirstCustomerMessage,
  getAnayticsForOutboundMessage,
  getSelectedUnSentMessage,
  extractSelectedTicketFromState,
  extractTicketFromStateById,
} from './../extractFromState';
import { getExpertId } from './parseSelectors';
import { removeUndefines, messageToClientFormat } from './util';
import { handleError } from 'services/ErrorService/ErrorService';

export const getReplySubject = (subject) => {
  let newSubject;
  if (subject === null || subject === undefined) {
    newSubject = 'Re:';
  } else {
    const currentSubject = subject.replace('<no subject>', ''); // I believe Outlook adds a <no subject> line
    if (currentSubject.indexOf('Re:') === -1) {
      newSubject = 'Re: ' + subject;
    } else {
      newSubject = subject;
    }
  }

  return newSubject;
};

export const getConversationById = async (conversationId) => {
  let conversation;

  try {
    conversation = await getConversation(conversationId);

    return conversation;
  } catch (error) {
    handleError({ error });
  }

  return conversation;
};

const getFirstMessageFromConversation = async (conversationId) => {
  const conversation = await getConversationById(conversationId);

  for (let i = 0; i < conversation.allMessages.length; i++) {
    const messageId = conversation.allMessages[i];
    const message = conversation[messageId];
    if (message.direction === 'INBOUND') {
      return message;
    }
  }
};
/**
 * Factory method to create a new message
 * @param {object} state Redux state
 * @param {string} newMessageText text to go in the outbound message
 * @param conversationId
 * @param macroCouponCodeTypeId
 * @param {string[]} [userConfirmedWords=[]] - List of words, smb names, and/or aliases confirmed by the user to be sent.
 */
export const createMessage = async (
  state,
  newMessageText,
  conversationId = null,
  macroCouponCodeTypeId = null,
  userConfirmedWords = []
) => {
  // use the first message customer as the basis for the new message
  let firstMessage;
  let analytics;
  let unsentMessage;
  let selectedTicket;

  if (conversationId) {
    firstMessage = await getFirstMessageFromConversation(conversationId);
    selectedTicket = extractTicketFromStateById(state, conversationId);
  } else {
    analytics = getAnayticsForOutboundMessage(state);
    unsentMessage = getSelectedUnSentMessage(state);
    firstMessage = extractFirstCustomerMessage(state);
    selectedTicket = extractSelectedTicketFromState(state);
  }

  if (!selectedTicket) {
    return null;
  }

  const { brand, ticketType, communicationType } = selectedTicket;
  const sanitazedMessage = messageToClientFormat(newMessageText, ticketType, communicationType);

  const expertId = getExpertId();
  // copy over unchanged properties
  const processedMessage = pick(firstMessage, [
    'conversationObjectId',
    'simplrAccountObjectId',
    'messageType',
    'platformDomain',
    'platformTicketId',
    'smbName',
  ]);
  // add other fields
  processedMessage.brand = brand;
  processedMessage.decisionTreeCouponCode = unsentMessage && unsentMessage.decisionTreeCouponCode;
  processedMessage.subject = getReplySubject(firstMessage.subject);
  processedMessage['attachment-count'] = 0;
  processedMessage.simplrExpertObjectId = expertId;
  processedMessage.mediaUrl = [];
  processedMessage.message = sanitazedMessage;
  processedMessage.macroCouponCodeTypeId = macroCouponCodeTypeId;
  processedMessage.userConfirmedWords = userConfirmedWords;
  // flip channels
  processedMessage.fromChannel = firstMessage.toChannel;
  processedMessage.toChannel = firstMessage.fromChannel;
  processedMessage.analytics = analytics && analytics;
  removeUndefines(processedMessage);

  return processedMessage;
};
